export default __webpack_public_path__ + "static/inline-prompt-light-aa2743994b333aa319472e75680f89b54491eaec480f5c67f6c2d9b09608caa4.png";